import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSH: CultureInfo = {
  name: 'en-SH',
  displayName: 'English (St. Helena)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SH',
  parent: CultureInfoEn
};
